import { PageAccess } from '../api/model/model';
import { useAuth } from '../contexts/auth';
import ErrorAccessDenied from 'components/errors/access-denied';
import { Page } from 'features/shared/model';
import React from 'react';
import { WithChildren } from 'ts-types';
import { toAbsoluteUrl } from 'utils/assets';

type Props = {
  page: Page;
};

const ProtectedRoute: React.FC<Props & WithChildren> = ({ children, page }) => {
  const { currentPermissions } = useAuth();

  if (!currentPermissions) {
    return (
      <div className="d-flex flex-column align-items-center justify-content-center">
        <img src={toAbsoluteUrl('/media/logos/logo.png')} alt="logo" className="h-35px" />
        <span className="mt-10">Loading ...</span>
      </div>
    );
  }

  const pagePermissions: PageAccess | undefined = currentPermissions?.find((item) => item.page == page);
  const hasPermission = pagePermissions && pagePermissions.access.read;

  return hasPermission ? <>{children}</> : <ErrorAccessDenied />;
};

export default ProtectedRoute;
